import type {TStore} from "modules/types/store";

export const getWeeklyPrizeModalData = (store: TStore) => store.weeklyPrizeModal.modal;
